import react, { ReactElement, VFC } from 'react';
import Modal from 'react-bootstrap/Modal';

import { Heading } from '@/components/Elements/Heading';
import { Button } from '@/components/Elements';

import './ConfirmationDialogV2.scss';
const ConfirmationDialogV2: VFC<{
  title: string;
  description: string;
  noButtonLabel: string;
  yesButtonLabel: string;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  children?: ReactElement;
  disabled?: boolean;
}> = ({
  title,
  description,
  open,
  onCancel,
  onConfirm,
  noButtonLabel,
  yesButtonLabel,
  children,
  disabled,
}) => {
  return (
    <>
      <Modal show={open} onHide={onCancel} className="petsked-modal-dialog confirmation-dialog-v2">
        <Modal.Header closeButton>
          <Heading size="lg" title={title} description={description} />
        </Modal.Header>
        <Modal.Body>
          <div className="confirmation-dialog-container">{children}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="inverse" size="lg" disabled={disabled} onClick={onCancel}>
            {noButtonLabel}
          </Button>
          <Button variant="primary" size="lg" disabled={disabled} onClick={onConfirm}>
            {yesButtonLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmationDialogV2;
